<template>
    <div class="relative">

        <input
            :id="inputID"
            inputmode="tel"
            v-imask="{
          mask: '+7 (900) 000-00-00',
          lazy: false,
          definitions: {'9': /[9]/},
          normalizeZeros: false,
          scale: 0
        }"
            @complete="onComplete"
            @accept="onAccept"
            class="peer w-full select-none rounded-xl border-2 border-transparent bg-white px-4 pb-3 pt-7 text-base placeholder-transparent shadow-main outline-none transition-colors focus:border-orange-200"
            :class="{
        '!border-red': errorMessage,
        '!pr-14': locked,
      }"
            :disabled="locked"
            type="text"
            autocomplete="off"
            :name="name"
            :value="value"
            placeholder="Введите"
        />
        <label
            :for="inputID"
            class="pointer-events-none absolute left-4 top-3 select-none text-xs text-[#777675] transition-all peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-focus:top-3 peer-focus:text-xs"
            :class="{
        'text-red': errorMessage,
      }"
        >
            {{ errorMessage || label }}
        </label>

        <button
            v-if="locked"
            class="absolute right-4 top-1/2 -translate-y-1/2"
            type="button"
            disabled
        >
            <IconLock class="aspect-square h-6" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'
import { watch } from 'vue'

const props = defineProps<{
    label?: string
    name: string
    locked?: boolean
    textCenter?: boolean
}>()

const emit = defineEmits(['changed'])

const inputID = uuidv4()

const { label, name, locked } = toRefs(props)

const onAccept = (e) => {
    console.log(e)
    emit('changed', e.detail.value.replace(/\D/g, ''))
}
const onComplete = (e) => {
    value.value =  e.detail.value.replace(/\D/g, '')
}

const {
    errorMessage,
    value,
    meta: { initialValue },
} = useField<string | undefined>(name)


watch(
    [() => initialValue],
    () => {
        if (initialValue) {
            value.value = initialValue
        }
    },
    {
        immediate: true,
    }
)
</script>
